module.exports = __webpack_public_path__ + "static/airmason_kyee-b0b3935b319d9920209cb160ea1bae64.png";